import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseDataService, BaseUpdateComponent, ModalService, QueryParameter, NotificationService, ytKontrolaPoModulu97, ZrcComponent } from 'yt-ng-framework';
import { CompanyZrc } from './company_zrc_new';
import { ActivatedRoute, Router } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, Validators } from '@angular/forms';
import { BankaView } from 'src/app/lookups/banka/banka-view';
import * as var_config from '../../../var_config';
// import { ToastrService } from 'ngx-toastr';
import { List } from 'immutable';


@Component({
  selector: 'yt-company-zrc-new-update',
  templateUrl: './company-zrc-new-update.component.html'
})
export class CompanyZrcNewUpdateComponent extends BaseUpdateComponent<CompanyZrc> implements OnInit {

  @ViewChild('zrcKontrola', { static: true }) zrcKontrola: ZrcComponent;
   sifraBanke: string = null;
   varConfig=var_config;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    protected router: Router,
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService, modalService, router)

  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Zrc", Validators.required, 'required', 'COMPANYZRC.ZRC.VALIDATION.REQUIRED');
    this.addValidatorToFc("Zrc", Validators.pattern('^[0-9]{3}-[0-9]{1,13}-[0-9]{2}$'), 'pattern', 'COMPANYZRC.ZRC.VALIDATION.PATTERN');
    this.addValidatorToFc("BankaID", Validators.required, 'required', 'COMPANYZRC.BANKA.VALIDATION.REQUIRED');
    this.baseFormGroup.setValidators(zrcControl('Zrc', this));
    
    this.IDProcessed
    .subscribe((value) => { 
      if (value && this.Item.ID == -1) {  
        this.baseFormGroup.patchValue({Zrc : ""});
      }
      else {
        this.TransferParameters = List([]);
        let parameterList: List<QueryParameter> = List([new QueryParameter('Devizni', this.Item.Devizni)]);
        this.TransferParameters = this.TransferParameters.set(0, parameterList);
        parameterList.clear();
      }
    })

    this.ItemSaved
      .subscribe((data: CompanyZrc) => {
        this.TransferParameters = List([]);
        let parameterList: List<QueryParameter> = List([new QueryParameter('Devizni', this.Item.Devizni)]);
        this.TransferParameters = this.TransferParameters.set(0, parameterList);
        parameterList.clear();
        this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.saveDisabled = this.Item.Devizni ? false : true;
        this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.resetDisabled = this.Item.Devizni ? false : true;
      
    })

  }

  onBankaSelect(value: BankaView) 
  {   
    //Zrc - fromControlName kontrole kojoj dodeljujem vrednot, value.Sifra - polje iz modela BankaView
    if (value){
      if (this.Item.ID == -1)
        this.baseFormGroup.patchValue({Zrc : value.Sifra});
      
      if (value.Sifra != "999")
        this.zrcKontrola.zrc1.disabled = true;
      
      this.sifraBanke = value.Sifra;
    }   
  }

  onRestoreClick(): void {
    this.Reset(true).subscribe((result) => {
        if (result) {
            console.log('Restore successfully executed');
        } else {
            console.log('Restore was cancelled by the user');
        }
    });
  }

}



function zrcControl(zrcControlKey: string, mainThis: any){
  return (group: FormGroup): {[key : string]: any} =>{
      let zrcControl : string = group.controls[zrcControlKey].value;
      let value : string = null;
      if (zrcControl){
        value = zrcControl.replace(/-/g,"");
        value = value.substr(0, value.length-2);
        let kontrolniBroj : string = null;
        kontrolniBroj = zrcControl.replace(/-/g,"");
        kontrolniBroj = kontrolniBroj.substr(kontrolniBroj.length-2, 2);
        let kontrola97 : string = null;

        if (mainThis.sifraBanke != null && mainThis.sifraBanke != "999")
        {
          kontrola97 = ytKontrolaPoModulu97(value);    
          if (kontrola97 && kontrola97 != kontrolniBroj)      
          return { 
            zrcControlNumbers : {valid : false, message : 'FW.KONTROLAPOMODULU.VALIDATION.MODUL97'}
          };
          else
            return null;
        }

        else
          return null;
      }
      else 
        return null;
     
      
  }
  
}

